import api from './api';

/** The four scoped permissions a Telegram staff link can grant. */
export interface TelegramLinkPermissions {
  canExpenses: boolean;
  canPayables: boolean;
  canAggregator: boolean;
  canInventory: boolean;
}

export interface TelegramLink extends TelegramLinkPermissions {
  id: number;
  displayName: string;
  staffMemberId: number | null;
  /** null once the invite has been claimed. */
  inviteCode: string | null;
  inviteExpiresAt: string | null;
  claimed: boolean;
  telegramUsername: string | null;
  claimedAt: string | null;
  isActive: boolean;
}

export interface CreateTelegramLinkPayload extends Partial<TelegramLinkPermissions> {
  staffMemberId?: number | null;
  displayName?: string;
}

export const telegramLinksApi = {
  list: () => api.get<TelegramLink[]>('/api/vendor/telegram-links'),

  create: (payload: CreateTelegramLinkPayload) =>
    api.post<TelegramLink>('/api/vendor/telegram-links', payload),

  updatePermissions: (id: number, permissions: Partial<TelegramLinkPermissions>) =>
    api.put<TelegramLink>(`/api/vendor/telegram-links/${id}/permissions`, permissions),

  /** Issue a fresh invite code (unclaimed links only). */
  regenerate: (id: number) =>
    api.post<TelegramLink>(`/api/vendor/telegram-links/${id}/regenerate`),

  /** Deactivate (soft-delete) a link. */
  deactivate: (id: number) => api.delete<void>(`/api/vendor/telegram-links/${id}`),
};
